import { sealData, unsealData } from 'iron-session';

export const seal = <T>(d: T, key: string) => sealData(d, { password: key });
export const unseal = <T>(s: string, key: string) => unsealData<T>(s, { password: key });
